import i from "../../../@babel/runtime/helpers/esm/slicedToArray.mjs";
import * as t from "react";
import u from "./useEvent.mjs";
function l(n) {
  var c = t.useReducer(function(e) {
    return e + 1;
  }, 0), o = i(c, 2), a = o[1], r = t.useRef(n), f = u(function() {
    return r.current;
  }), s = u(function(e) {
    r.current = typeof e == "function" ? e(r.current) : e, a();
  });
  return [f, s];
}
export {
  l as default
};
//# sourceMappingURL=useSyncState.mjs.map
